let paymentBatchPagePromise

export const loadPaymentBatchPage = () => {
  if (!paymentBatchPagePromise) {
    paymentBatchPagePromise = import('./payment-batch').catch((error) => {
      paymentBatchPagePromise = undefined
      throw error
    })
  }

  return paymentBatchPagePromise
}

export const preloadPaymentBatchPage = () => {
  // A route navigation can retry if this speculative request fails.
  loadPaymentBatchPage().catch(() => undefined)
}
